<template>
  <header class="header">
    <IconButton
      icon="back"
      class="header__back"
      :class="{ header__back_hidden: isBackHidden }"
      @click="emitBack"
    />
    <button
      class="header__logo"
      @click="onLogoClick"
    >
      <Logo />
    </button>
  </header>
</template>

<script>
import CONSTANTS from '@/helpers/constants';

import IconButton from '@/components/IconButton.vue';
import Logo from '@/assets/icons/logo.svg';

export default {
  name: 'TheHeader',
  components: {
    IconButton,
    Logo,
  },
  data() {
    return {
      clickCount: 0,
    };
  },
  staticData: () => ({
    clickTimeout: null,
  }),
  computed: {
    isBackHidden() {
      return !this.$route.meta?.back;
    },
  },
  beforeDestroy() {
    this.clearClickTimeout();
  },
  methods: {
    emitBack() {
      this.$root.$emit(CONSTANTS.ACTION_GO_BACK);
    },
    onLogoClick() {
      const adminPath = this.$router.options.paths.admin;
      if (this.$route.path === adminPath) {
        return;
      }
      this.clickCount += 1;
      if (this.clickCount >= 5) {
        this.$router.push(adminPath);
        this.clearClickCount();
        this.clearClickTimeout();
      }
      if (!this.clickTimeout) {
        this.clickTimeout = window.setTimeout(() => {
          this.clearClickCount();
          this.clearClickTimeout();
        }, 2000);
      }
    },
    clearClickCount() {
      this.clickCount = 0;
    },
    clearClickTimeout() {
      window.clearTimeout(this.clickTimeout);
      this.clickTimeout = null;
    },
  },
};
</script>

<style lang="stylus">
.header
  display flex
  align-items center
  padding-left $side_padding
  padding-right @padding-left

  &__back
    pointer-events auto
    transition opacity 200ms
    &_hidden
    .screen_pending ~ .app__header &
    .screen_header_hidden ~ .app__header &
      visibility hidden
      opacity 0

  &__logo
    width 9.2em
    height 2.9em
    padding 0
    background none
    border 0
    outline none
    margin-left 1em
    transition transform 200ms
    pointer-events auto
    cursor default
    svg
      display block
      width 100%
      height 100%

    .screen_full ~ .app__header &
      visibility hidden

    ~/__back_hidden ~ &
      transform translate(-2.9em, 0)
      margin-left 0
</style>
